<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Pengguna"
        class="card-wrapper"
        >
        <form >
          <div style="height: 80px" class="form-input row">
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Username/Nama</p>
              <v-text-field
                v-model="searchForm.username"
                placeholder="Cari berdasarkan Username/Nama"
                dense
                outlined
              />
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)</p>
              <v-autocomplete
                :items="filteredOrganisasi"
                :item-text="item => item.nama"
                :item-value="item => item.id"
                v-model="searchForm.idOrganisasi"
                no-data-text="Tidak ada data"
                placeholder="Cari berdasarkan Organisasi (PAU/Fakultas/Sekolah)"
                clearable
                dense
                outlined
                @keydown.enter.prevent
            ></v-autocomplete>
            </div>
            <div class="col-2">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchPengguna()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          <br>
        </form>
        <v-card>
        <v-card-title>            
            <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari Nama Pengguna"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn v-if="this.currentPeran !=='A04'"
                color="primary"
                class="mr-4"
                @click="addItem()"
            >
              Tambah
            </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="penggunas"
            :search="search"
            :options.sync="tableOptions"
            :loading="isLoading"
            no-data-text="Data Pengguna tidak ditemukan"
            no-results-text="Data Pengguna tidak ditemukan"
            loading-text="Memuat data..."
            hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
        <template v-slot:item.status="{ item }">
            <esign-status-tag :tone="item.status == true ? 'success' : 'neutral'">{{ item.status == true ? "Aktif" : "Tidak Aktif" }}</esign-status-tag>
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" x-small color="primary" dark @click="detailItem(item)"><v-icon small class="mr-1"> mdi-eye </v-icon>Detail</v-btn>
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="orange" dark @click="editItem(item)"><v-icon small class="mr-1"> mdi-pencil </v-icon>Ubah</v-btn>
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="red" dark @click="resetPasswordItem(item)"><v-icon small class="mr-1"> mdi-key </v-icon>Reset Password</v-btn>
          </template>
        </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card class="card-modal">
            <v-card-title>
              <span class="headline">Reset Password Pengguna</span>
            </v-card-title>
  
            <v-card-text>
              Apakah anda yakin ingin mereset password pengguna {{namaPengguna}}?
            </v-card-text>
  
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn @click="close">Batal</v-btn>
              <v-btn color="primary" dark @click="resetPasswordItemConfirm">Ya</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";

export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "searchForm", "tableOptions"],
  restoreAfterLoad: ["tableOptions"],
  data () {
    return {
      namaPengguna: "",
      penggunas: [],
      organisasis: [],
      search: '',
      tableOptions: {},
      usernameReset: "",
      currentPeran: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      isLoading: true,
      dialog: false,
      totalData: 0,
      headers: [
        {
          text: 'Nama Lengkap',
          align: 'start',
          sortable: false,
          value: 'nama_lengkap',
        },
        { text: 'Username', 
          sortable: false,
          value: 'username' 
        },
        { text: 'Organisasi (PAU/Fakultas/Sekolah)', 
          sortable: false,
          value: 'nama_organisasi' 
        },
        { text: 'Email', 
          sortable: false,
          value: 'email' 
        },
        { text: 'Status', 
          sortable: false,
          value: 'status' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'aksi',
          width: '350px',
        },
      ],      
      searchForm: {
        namaPengguna: "",
        idOrganisasi: -1,
      }
    }
  },
  created() {
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    console.log("loading")
    this.getData();
    this.getOrganisasi();
  },
  computed: {
      filteredPengguna(){
          return this.penggunas.filter(item => item.status)
      },
      filteredOrganisasi(){
          return this.organisasis.filter(item => item.status)
      }
  },
  methods: {
    getData() {
      this.isLoading = true;
      console.log(this.isLoading);
      console.log("form data:");
      console.log(this.searchForm);
      apiServer
        .get("/pengguna/all", {
          params: {
              username: this.searchForm.username,
              idorg: this.searchForm.idOrganisasi
            }})
        .then(response => {
          console.log("responded");
          this.penggunas = response.data.data;
          console.log(response.data.data)
          this.isLoading = false;
          this.totalData = response.data.total
          if(localStorage.getItem("createSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("createSuccess"));
            this.close()
            localStorage.removeItem("createSuccess")
          }
          if(localStorage.getItem("updateSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("updateSuccess"));
            this.close()
            localStorage.removeItem("updateSuccess")
          }
          this.currentPeran = localStorage.getItem("currentPeran")
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    getOrganisasi() {
      this.isLoading = true;
      apiServer
          .get("/organisasi/all")
          .then(response => {
            this.organisasis = response.data.data;
            console.log("search organisasi loaded")
            console.log(this.organisasis)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          });
    },
    searchPengguna() {
      if(!this.searchForm.namaPengguna) {
        this.searchForm.namaPengguna = ""
      }
      if(!this.searchForm.idOrganisasi) {
        this.searchForm.idOrganisasi = -1
      }
      this.getData()
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    detailItem(item){
      this.$router.push('/pengguna/detail/' + item.id);
    },
    addItem(){
      this.$router.push('/pengguna/tambah');
    },
    editItem(item){
      console.log(item)
      this.$router.push('/pengguna/ubah/' + item.id);
    },
    resetPasswordItem(val) {
      this.dialog = true
      this.usernameReset = val.username
      console.log("reset password " +this.usernameReset)
    },
    resetPasswordItemConfirm(item){
      console.log(item)
      let resetData = new FormData()
      resetData.append("Username", this.usernameReset)
      resetData.append("Password", this.usernameReset)
      apiServer
        .put("/pengguna/reset-password", resetData)
        .then(response => {
          console.log("Successfully reset password")
          this.showSnackbar("success", "Reset Password berhasil dilakukan, silakan cek Email pengguna "+this.usernameReset);
          this.close()
        })
    },
    close() {
      this.usernameDelete = ""
      this.dialog = false;
    }
  }
}
</script>